import React from 'react';
import {Helmet} from 'react-helmet';
import {AppLayout} from '../../../components';
import {GetProfileOverviewQueryData} from '../graphql/GetProfileOverviewQuery.graphql';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import i18nArgs from '../locales';
import {
  Profile as ProfileUtils,
  serviceListingsToServiceDimensionsMap,
} from 'sections/services-marketplace/experts/utilities';
import {ExpertDetails, ServiceListings, ExpertUnavailable} from '../components';
import {StringMap} from 'utilities/types';
import {ServiceDimension} from 'sections/types';
import {Routes} from 'sections/services-marketplace/experts/utilities/routes';

interface OwnProps {
  profile: GetProfileOverviewQueryData.Profile;
}

type CombinedProps = OwnProps & WithI18nProps;

interface State {
  currentFilter: string[];
  serviceDimensionsMap: StringMap<ServiceDimension>;
}

class Profile extends React.Component<CombinedProps, State> {
  state: State = {
    currentFilter: [''],
    serviceDimensionsMap: serviceListingsToServiceDimensionsMap(
      this.props.profile.serviceListings
    ),
  };

  onFilterChange = (currentFilter: string[]) => {
    this.setState({currentFilter});
  };

  render() {
    const {
      profile: {
        businessName,
        bio,
        serviceListings,
        image,
        address,
        languages,
        handle,
        acceptingLeads,
      },
      i18n,
    } = this.props;
    const {currentFilter, serviceDimensionsMap} = this.state;

    const topServices = serviceListings
      .slice(0, 5)
      .map(serviceListing => serviceListing.shortLabel.toLowerCase())
      .join(', ');

    const canonicalPath = `https://experts.shopify.com${Routes.profilePath(
      handle
    )}`;

    return (
      <>
        <Helmet>
          <title>
            {i18n.translate('Profile.Meta.profileTitle', {
              businessName,
            })}
          </title>
          <meta
            name="description"
            content={i18n.translate('Profile.Meta.profileDescription', {
              businessName,
              topServices,
            })}
          />
          <link rel="canonical" href={canonicalPath} />
        </Helmet>
        <AppLayout>
          <AppLayout.Container slim>
            <AppLayout.Section size="TwoThirds">
              {!acceptingLeads && <ExpertUnavailable />}
              <ExpertDetails
                bio={bio}
                currentOrganization={{
                  businessName,
                  address,
                }}
                expertHandle={handle}
                languages={languages}
                languageList={ProfileUtils.getLanguageMap()}
                profileImage={image}
              />
            </AppLayout.Section>
          </AppLayout.Container>
          <AppLayout.Container slim>
            <ServiceListings
              expertHandle={handle}
              serviceListings={serviceListings}
              currentFilter={currentFilter}
              onFilterChange={this.onFilterChange}
              serviceDimensionsMap={serviceDimensionsMap}
            />
          </AppLayout.Container>
        </AppLayout>
      </>
    );
  }
}

export default withI18n(i18nArgs)(Profile);
